import { render, staticRenderFns } from "./clientProfileIdentifiers.vue?vue&type=template&id=7577e7d2"
import script from "./clientProfileIdentifiers.vue?vue&type=script&lang=js"
export * from "./clientProfileIdentifiers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports